export default {"src":"/_next/static/media/moveBack.66c3c943.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};